import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import HowWeWork from '../components/HowWeWork';
import Clients from '../components/Clients';
import Footer from '../components/Footer';
import ScrollToTop from '../components/ScrollToTop';
import { Building2 } from 'lucide-react';

function Home() {
  useEffect(() => {
    document.title = 'Hop Shing - Professional Waterproofing Solutions';
    window.scrollTo(0, 0);
  }, []);

  const handleLearnMoreClick = () => {
    window.scrollTo(0, 0);
  };

  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      
      {/* About Section */}
      <section className="py-20 bg-white">
        <div 
          className="container mx-auto px-4"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-once="true"
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div 
              className="relative rounded-lg overflow-hidden transform transition-all duration-500 hover:scale-105"
              data-aos="fade-right"
              data-aos-delay="200"
            >
              <img 
                src="/assets/images/HSEC_Portfolio_01.jpg"
                alt="About Our Company"
                className="w-full h-[400px] object-cover"
              />
              <div className="absolute inset-0 bg-black bg-opacity-10"></div>
            </div>
            
            <div
              data-aos="fade-left"
              data-aos-delay="400"
            >
              <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">About Us</h2>
              <div className="w-24 h-1 bg-[#ff2910] mb-6"></div>
              <p className="text-gray-600 mb-6 text-justify">
            Hop Shing Engineering & Construction's journey began in 1989 when Chairman Louis Mo established his vision for waterproofing excellence. From these foundations, we've grown into a specialist serving diverse construction markets.
              </p>
              <p className="text-gray-600 mb-6 text-justify">
                Our mission is to provide high-quality services that exceed our clients' expectations. We are committed to maintaining the highest standards of professionalism, integrity, and excellence in all that we do.
              </p>
              <Link 
                to="/about"
                onClick={handleLearnMoreClick}
                className="inline-block bg-[#ff2910] text-white px-8 py-3 rounded-md hover:bg-[#b00612] transition-all duration-300 transform hover:scale-105"
              >
                Learn More
              </Link>
            </div>
          </div>
        </div>
      </section>

      <HowWeWork />

      {/* Project Overview Section */}
      <section 
        className="py-8 bg-gray-50"
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-once="true"
      >
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <div 
              className="inline-block p-4 bg-[#ff2910] bg-opacity-10 rounded-full mb-6"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <Building2 size={40} className="text-[#ff2910]" />
            </div>
            <h2 
              className="text-3xl md:text-4xl font-bold text-gray-800 mb-4"
              data-aos="fade-up"
              data-aos-delay="300"
            >
              Project Overview
            </h2>
            <div className="w-24 h-1 bg-[#ff2910] mx-auto mb-6"></div>
            <p 
              className="text-xl text-gray-600 mb-8"
              data-aos="fade-up"
              data-aos-delay="400"
            >
              With over <span className="text-[#ff2910] text-4xl md:text-5xl font-bold inline-block transform -translate-y-1">1,000+</span> successful projects completed, 
              Hop Shing Engineering & Construction has established itself as a leader in waterproofing solutions 
              across diverse construction sectors.
            </p>
            <div
              data-aos="fade-up"
              data-aos-delay="500"
            >
              <Link 
                to="/project"
                onClick={handleLearnMoreClick}
                className="inline-block bg-[#ff2910] text-white px-8 py-3 rounded-md hover:bg-[#b00612] transition-all duration-300 transform hover:scale-105 shadow-md hover:shadow-lg"
              >
                View Featured Projects
              </Link>
            </div>
          </div>
        </div>
      </section>
      
      <Clients />

      <ScrollToTop />
      <Footer />
    </div>
  );
}

export default Home;